import http from "./HttpService";


  const fetchBackendAutocomplete = async (prov, q, sessionToken, regionCode = " ") => {
    console.log("FETCH SUGGESTIONS", prov, q);
    const res = await http.get('/geosearch/autocomplete', {
      params: {
        provider: prov,
        q: q,
        sessionToken: sessionToken,
        regionCode: regionCode
      }
    });

    if (res?.status !== 200) return [];
    const {suggestions = []} = res.data;
    
    return suggestions;
  };

  const fetchBackendDetails = async (prov, id, sessionToken) => {
    console.log("FETCH DETAILS", prov, id);
    
    const res = await http.get(
      `/geosearch/details?provider=${prov}&id=${encodeURIComponent(id)}&sessionToken=${encodeURIComponent(sessionToken)}`
    );
    if (res?.status !== 200) return null;
    
    return res.data;
  };

const fetchReverseGeocode = async (prov, lat, lon) => {
  console.log("FETCH REVERSE", prov, lat, lon);
  const res = await http.get(
    `/geosearch/reverse?provider=${prov}&lat=${lat}&lon=${lon}`
  );
  
  if (res?.status !== 200 || res.data?.error) return null;
  
  return res.data;
};

export default {
  fetchBackendAutocomplete,
  fetchBackendDetails,
  fetchReverseGeocode,
};
